module.exports = __webpack_public_path__ + "img/revolution.4a0f8669.png";